/** Only old homepage fragment URLs are remapped. Ordinary links keep native history. */
export function legacyDestination(href, routes) {
  const current = new URL(href), home = new URL(routes.home);
  if (current.origin !== home.origin || current.pathname !== home.pathname) return null;
  const targets = {
    '#solutions': ['solutions', ''], '#process': ['solutions', '#process'],
    '#demo-studio': ['solutions', '#demo-studio'], '#website-demo': ['solutions', '#website-demo'], '#app-demo': ['solutions', '#app-demo'],
    '#ai-scan': ['finder', ''], '#company': ['company', ''], '#faq': ['company', '#faq'], '#contact': ['contact', ''],
  };
  const target = targets[current.hash];
  if (!target || !routes[target[0]]) return null;
  const next = new URL(routes[target[0]]);
  next.hash = target[1];
  const enquiry = current.searchParams.get('enquiry');
  if (target[0] === 'contact' && ['success', 'error'].includes(enquiry)) next.searchParams.set('enquiry', enquiry);
  return next.href;
}
